function revealPrice(el) {
  const text = (el.dataset.priceP1 || '') + (el.dataset.priceP2 || '') + (el.dataset.priceP3 || '');
  if (el.matches('meta')) {
    el.setAttribute('content', text);
  } else {
    el.textContent = text;
  }

  if (el.hasAttribute('value')) {
    el.setAttribute('value', text);
  }
}

function revealPrices(root) {
  root.querySelectorAll('[data-price-p1]').forEach(revealPrice);
}

document.addEventListener('DOMContentLoaded', () => {
  revealPrices(document);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.hasAttribute('data-price-p1')) revealPrice(node);
          revealPrices(node);
        }
      } else if (mutation.type === 'attributes') {
        revealPrice(mutation.target);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-price-p1'],
  });
});
